import { useEffect } from 'react';
import { ERRORS } from '../../constants/AppConstants';


const RightStickyForm = ({
    stickyText,
    setStickyText,
    stickyPosition,
    setStickyPosition,
    stickyBgColor,
    setStickyBgColor,
    isDiscarded,
    setIsDiscarded,
    setIsDirty,
    stickyTextError,
    setStickyTextError,
}) => {
    
    useEffect(() => {
        if(isDiscarded) {
            setStickyTextError(null);
            setIsDiscarded(false);
        }
    }, [isDiscarded])

    
    const handelTitleValidation = (value) => {
        setStickyText(value)
        setIsDirty(true);
        if(value.length <= 0 ) {
            setStickyTextError(ERRORS.PERMISSION_PROMPT_ERRORS.STICKY_TEXT_REQUIRED);
        }
        else {
            setStickyTextError(null);
        }
    }
    return <><div className="form-group">                   
        <label className="form-label text-dark regular full-width">Sticky Text
        <span className="float-right">{stickyText.length} / 17</span></label>
        <div className="d-flex">
            <input 
                type="text" 
                className="form-control" 
                value={stickyText} 
                onChange={({target}) => handelTitleValidation(target.value)}
                maxLength={17} 
            />
        </div> 
        {stickyTextError && <span className="error-message">{stickyTextError}</span>}                                                       
    </div> 
    <div className="d-flex justify-content-between align-items-center mb-3">
        <label>Sticky position</label>
        <div className="btn-group" role="group" aria-label="Basic example">
            <button 
                type="button" 
                className= {stickyPosition === 'left' ? 'btn btn-primary': 'btn btn-outline' }
                onClick={() => setStickyPosition('left')}
            ><i className="icon "></i>Left</button>
            <button 
                type="button" 
                className= {stickyPosition === 'right' ? 'btn btn-primary': 'btn btn-outline' }
                onClick={() => setStickyPosition('right')}    
            ><i className="icon "></i>Right</button>
        </div>
    </div>
    <div className="d-flex justify-content-between align-items-center mb-3">
        <label>Color Palatte</label>
        <div>
            <input 
                type="color" 
                value={stickyBgColor}
                onChange={({target}) => setStickyBgColor(target.value)}    
            />
        </div>
    </div>
</>
}

export default RightStickyForm;